import request from '@/utils/request'
import service from '@/utils/service'
// H5页面获取设置信息
export function getRecommendConfig() {
  return request({
    url: '/zhixiao/api/recommend/driver/pageInfo',
    method: 'get'
  })
}

// 获取微信分享信息
export function getShareConfig() {
  return request({
    url: '/zhixiao/api/recommend/driver/appInfo',
    method: 'get'
  })
}

// H5页面获取设置信息
export function saveRecommendInfo(data) {
  return request({
    url: '/zhixiao/api/v2/recommend/driver/v2',
    method: 'post',
    data
  })
}

// 获取活动积分
export function getCredit(data) {
  return service({
    url: '/driver/h5/inviteIntegral',
    method: 'post',
    data
  })
}

// 获取其他活动积分
export function getCreditList(data) {
  return request({
    url: '/zhixiao/api/activity/getAwardRule',
    method: 'get',
    data
  })
}
